import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useSingleMinigrid } from '../../../hook'
import minigridAPI from '../../../service/minigridAPI'
import styles from './MetersLink.module.scss'

export default function MetersLinkPresenter() {
  const navigate = useNavigate()
  const {
    singleMinigridQuery: { data: minigrid },
  } = useSingleMinigrid()
  const locationsQuery = useQuery({
    queryKey: ['minigridLocations'],
    queryFn: () => minigridAPI.getMinigridLocations(),
    staleTime: 5 * 60 * 1000,
  })

  const linkedName = minigrid?.minigrid_id
    ? locationsQuery.data?.find(
        (l) => l.linkedMinigrid?.minigrid_id === minigrid.minigrid_id,
      )?.linkedMinigrid?.minigrid_name?.trim() ?? ''
    : ''

  if (!linkedName) return null

  const handleClick = () => {
    navigate(`/main/meters?location=${encodeURIComponent(linkedName)}`)
  }

  return (
    <button
      type="button"
      className={styles.btn}
      onClick={handleClick}
      title={`Voir les compteurs filtrés sur « ${linkedName} »`}
    >
      Voir les compteurs
    </button>
  )
}
